import { formatNumberToLocale } from '@/composables/useFormatNumberToLocale'
import type { UiOfferTipsProps } from '@afs/design-system/components/molecules/UiOfferTips/interface.d.ts'

import type { ProductType } from '~/extensions/product/product.type'
import type { SimulationProposalType } from '~/extensions/simulator/simulator.type'
import type { SubProductType } from '~/extensions/subProduct/subProduct.type'

export function mapRefreshUiOffersProps(simulationResponse: SimulationProposalType) {
  return {
    title: 'Montant emprunté',
    amount: `${formatNumberToLocale(simulationResponse?.loanAmount)}`,
    duration: '€',
    caption: `Pendant ${formatNumberToLocale(simulationResponse?.numberOfPayments)} mois`,
    informations: [
      {
        label: 'TAEG fixe',
        value: `${formatNumberToLocale(simulationResponse?.annualPercentageRate)} %`,
      },
      {
        label: 'Mensualités',
        value: `${formatNumberToLocale(simulationResponse?.monthlyPaymentNoInsurance)} €`,
      },
      {
        label: 'Coût total du crédit',
        value: `${formatNumberToLocale(simulationResponse?.totalInterestAmount)} €`,
      },
      {
        label: "Montant total dû par l'emprunteur",
        value: `${formatNumberToLocale(simulationResponse?.totalAmountNoInsurance)} €`,
      },
    ],
  }
}

export function mapOfferTipsBlock(
  data: SubProductType | ProductType,
  simulationResponse: SimulationProposalType,
  offer?: string,
  subOffer?: string,
): UiOfferTipsProps | undefined {
  if (
    !(
      data.fields.display_tips_block &&
      data.fields.offer_tips_block_title &&
      data.fields.offer_tips_block_cta_label &&
      data.fields.offer_tips_block_illustration
    )
  )
    return undefined
  let path = `/simulateur/?amount=${simulationResponse?.loanAmount}`
  if (offer) path += `&offer=${offer}`
  if (offer && subOffer) path += `&subOffer=${subOffer}`
  return {
    title: data.fields.offer_tips_block_title,
    cta: {
      text: data.fields.offer_tips_block_cta_label,
      to: path,
    },
    illustration: data.fields.offer_tips_block_illustration,
    offer: mapRefreshUiOffersProps(simulationResponse),
  }
}
